export enum ActionType {
  NONE = 'none',
  CREATE = 'create',
  GET_BY_CODE = 'get by code',
  GET_ALL = 'get all',
  SEARCH_BY_CODE_NOM = 'search by code or nom',
  GET_BY_ID = 'get by id',
}
